import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import LicenseStatusDot from "~/shared/ui/LicenseStatusDot";
import { applySortToColumns } from "~/shared/ui/TableV2";
import { InfoTooltip } from "~/shared/ui/Tooltip";

import { ILicenseSummaryRow, LICENSES_TOTALS_ROW_ID } from "./types";

export const LICENSES_SORTABLE_COLUMNS = [
  "inn",
  "branchCode",
  "organizationName",
  "overallState",
  "totalQuantity",
  "assignedQuantity",
  "frozenQuantity",
  "freeQuantity",
  "expiredQuantity",
];

export const getLicensesColumns = (
  t: TFunction,
  sortField?: string,
  sortType?: string,
  licenseType?: string,
): ColumnsType<ILicenseSummaryRow> => {
  const columns: ColumnsType<ILicenseSummaryRow> = [
    {
      title: t("trainingManagement.table.inn"),
      dataIndex: "inn",
      key: "inn",
      width: 120,
    },
    {
      title: t("trainingManagement.table.branchCode"),
      dataIndex: "branchCode",
      key: "branchCode",
      width: 100,
    },
    {
      title: t("trainingManagement.table.organizationName"),
      dataIndex: "organizationName",
      key: "organizationName",
      width: 220,
    },
    {
      title: t("trainingManagement.table.licenseType"),
      dataIndex: "licenseType",
      key: "licenseType",
      width: 160,
      render: (_, record) =>
        record.id === LICENSES_TOTALS_ROW_ID
          ? t("trainingManagement.licenseTypes.all")
          : licenseType && licenseType !== "all"
            ? t(`trainingManagement.licenseTypes.${licenseType}`)
            : t("trainingManagement.filter.all"),
    },
    {
      title: (
        <span style={{ display: "inline-flex", alignItems: "center" }}>
          {t("trainingManagement.table.overallStatus")}
          <InfoTooltip
            content={t("trainingManagement.table.overallStatusLegend")}
            placement="bottom"
          />
        </span>
      ),
      dataIndex: "overallState",
      key: "overallState",
      width: 140,
      align: "center",
      render: (_, record) => (
        <LicenseStatusDot color={record.availabilityColor} />
      ),
    },
    {
      title: t("trainingManagement.table.total"),
      dataIndex: "totalQuantity",
      key: "totalQuantity",
      width: 140,
      align: "center",
    },
    {
      title: t("trainingManagement.table.statusGroup"),
      className: "trainingStatusGroupHeader",
      children: [
        {
          title: t("trainingManagement.table.issuedInDealerPassport"),
          dataIndex: "assignedQuantity",
          key: "assignedQuantity",
          width: 150,
          align: "center",
          className: "trainingStatusGroupCell trainingStatusGroupCellFirst",
        },
        {
          title: t("trainingManagement.table.used"),
          dataIndex: "usedQuantity",
          key: "usedQuantity",
          width: 120,
          align: "center",
          className: "trainingStatusGroupCell",
        },
        {
          title: t("trainingManagement.table.frozen"),
          dataIndex: "frozenQuantity",
          key: "frozenQuantity",
          width: 110,
          align: "center",
          className: "trainingStatusGroupCell",
        },
        {
          title: t("trainingManagement.table.free"),
          dataIndex: "freeQuantity",
          key: "freeQuantity",
          width: 100,
          align: "center",
          className: "trainingStatusGroupCell",
        },
        {
          title: t("trainingManagement.table.expired"),
          dataIndex: "expiredQuantity",
          key: "expiredQuantity",
          width: 110,
          align: "center",
          className: "trainingStatusGroupCell",
        },
      ],
    },
  ];

  return applySortToColumns(
    columns,
    sortField,
    sortType,
    LICENSES_SORTABLE_COLUMNS,
  );
};
